import styles from "./messageWindow.module.scss";
import { ModalWindow } from "../modalWindow/modalWindow";

type MessageWindowProps = {
  onClose: (isConfirm: boolean) => void;
  title: string;
  description: string | JSX.Element | JSX.Element[];
  primaryText: string;
  secondaryText?: string;
}

export const MessageWindow = ({onClose, title, description, primaryText, secondaryText}: MessageWindowProps) => {
  return (
    <ModalWindow onClose={() => onClose(false)}
                 width={377}
                 title={title}
                 children={
      <div className={styles.container}>
        <div className={styles.description}>{description}</div>
        <div className={styles.buttons}>
          { !!secondaryText && (
            <button className={styles.secondary} onClick={() => onClose(false)}>{secondaryText}</button>
          )}
          <button className={styles.primary} onClick={() => onClose(true)}>{primaryText}</button>
        </div>
      </div>
    }
    />
  );
}